// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
  speed: 1000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 4000, //　スライダー表示時間
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


function applyLoadedAndAnimate() {
  // 0.5秒後に .loaded 追加
  setTimeout(() => {
    document.body.classList.add("loaded");
  }, 500);

  // 1秒後に .svg-anim をすべて発火
  setTimeout(() => {
    document.querySelectorAll(".svg-anim").forEach(anim => {
      if (typeof anim.beginElement === "function") {
        anim.beginElement();
      }
    });
  }, 1000);
}

// 通常の DOMContentLoaded を待つ場合
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", applyLoadedAndAnimate);
} else {
  // 保険：すでに読み込み済みなら即処理
  applyLoadedAndAnimate();
}